/*
 * Copyright © 2023 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import trackerConfig from '../config/trackerConfig';
import User from '../model/User';

class UserHelper {
  static _getUser() {
    let user = null;
    const userStr = localStorage.getItem(trackerConfig.userStorageKey);
    if (userStr?.length > 0) {
      user = new User(JSON.parse(userStr).profile.preferred_username);
    }
    return user;
  }
}

export default UserHelper;
